import React, { useState, useEffect } from 'react';
import { Table, Header, Icon, TextFilter, TableProps, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { getParameter } from '../../../commons/functions';

const pageSize = 20;

type UserProperty = {
    idPropiedad: number;
    propiedad: string;
    RUT: string;
};
export const AdminPropertiesPage = () => {
    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { propiedad, setPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();
    const [properties, setProperties] = useState<UserProperty[]>([]);
    const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data
    const { gData, setGData } = useGlobalState();
    //const { finish, setFinish } = useGlobalState(false);

    const [filteringText, setFilteringText] = useState('');
    const [sortingColumn, setSortingColumn] = useState({
        sortingField: 'propiedad',
        isDescending: false,
    });
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    //const [loading, setLoading] = useState<boolean>(true);
    const { setLoading } = useGlobalState();
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [init, setInit] = useState(false);
    const handleRowClick = async (rowData: any) => {
        try {
            setIdPropiedad(rowData.idPropiedad);
            setPropiedad(rowData.SNPropiedad);
            try {
                setLoading(true);
                const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/admin/properties/profile/default.property',
                        'JWT': JWT,

                    },
                    body: JSON.stringify({
                        idPropiedadAdmin: idPropiedad,
                        idPropiedadDefault: rowData.idPropiedad
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                setJWT(data.JWTRenew)
                storeAdmin(data);
                setInit(true)
                //setFinish(true)


            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const returnURL = getParameter(window.location.hash, 'returnURL');
    
    useEffect(() => {
        if (init) {
            console.log("init")

            console.log("returnURL: " + returnURL);
            (returnURL && returnURL === '' ? window.location.hash = '#home' : window.location.hash = returnURL);

        };

    }, [init]);
    useEffect(() => {
    }, [selectedRow]);
    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/users/user/login',
                    'JWT': JWT,

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            //storeAdmin(data);
            setProperties(data.admin.properties);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    type SortableFields = keyof UserProperty;

    const filteredProperties = properties.filter(property => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        return searchWords.every(word =>
            property.propiedad.toLowerCase().includes(word) ||
            property.idPropiedad.toString().toLowerCase().includes(word)
        );
    });
    const field = sortingColumn.sortingField as SortableFields;

    const sortedProperties = [...filteredProperties].sort((a, b) => {
        const aValue = a[field];
        const bValue = b[field];

        const isNumeric = !isNaN(Number(aValue)) && !isNaN(Number(bValue));

        if (isNumeric) {
            const numA = Number(aValue);
            const numB = Number(bValue);
            return sortingColumn.isDescending ? numB - numA : numA - numB;
        } else {
            const strA = aValue?.toString().toLowerCase() ?? "";
            const strB = bValue?.toString().toLowerCase() ?? "";
            if (strA < strB) return sortingColumn.isDescending ? 1 : -1;
            if (strA > strB) return sortingColumn.isDescending ? -1 : 1;
            return 0;
        }
    });
    useEffect(() => {
        handleRefresh();
    }, []);

    type SortingChangeHandler = TableProps<UserProperty>['onSortingChange'];

    const handleSortingChange: SortingChangeHandler = (event) => {
        const { sortingColumn: eventSortingColumn, isDescending: eventIsDescending } = event.detail;

        setSortingColumn((prevSortingColumn) => ({
            sortingField: eventSortingColumn?.sortingField || 'propiedad',
            isDescending:
                prevSortingColumn.sortingField === eventSortingColumn?.sortingField
                    ? !prevSortingColumn.isDescending
                    : false, // Default to ascending when a new column is clicked
        }));
        // your logic
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Administradores', href: '#admin/default' },
                        { text: 'Propiedades', href: '#create-transcription-job' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">
                    <Header>Seleccione propiedad</Header>
                    <Table

                        filter={
                            <TextFilter
                                filteringText={filteringText}
                                onChange={({ detail }) => {
                                    setFilteringText(detail.filteringText);
                                }}
                            />
                        }

                        sortingColumn={sortingColumn}
                        onSortingChange={handleSortingChange} // ✅ You were missing this line!
                        sortingDescending={sortingColumn.isDescending} // ✅ Use your dynamic value
                        stripedRows
                        renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
                            `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
                        }
                        onRowClick={({ detail }) => handleRowClick(detail.item)}
                        columnDefinitions={[
                            {
                                id: "idPropiedad",
                                header: "ID",
                                cell: (item) => (
                                    <>
                                        {item.idPropiedad === idPropiedad ? (
                                            <strong>{item.idPropiedad}</strong>
                                        ) : (
                                            item.idPropiedad
                                        )}
                                    </>
                                ),
                                maxWidth: 40,
                                sortingField: "idPropiedad",
                            },
                            {
                                id: "propiedad",
                                header: "Propiedad",
                                cell: (item) => (
                                    <>
                                        {item.idPropiedad === idPropiedad ? <Icon name='heart-filled' variant="error" /> : ''}
                                        {' '}
                                        {item.idPropiedad === idPropiedad ? (
                                            <strong>{item.propiedad}</strong>
                                        ) : (
                                            item.propiedad
                                        )}
                                    </>
                                ),
                                sortingField: "propiedad",
                                isRowHeader: true,
                            },
                            {
                                id: "RUT",
                                header: "RUT",
                                cell: (item) => item.RUT,
                                //sortingField: "displayName",
                            },
                        ]}
                        items={sortedProperties}
                        selectionType={undefined}
                        trackBy="idPropiedad"
                    />

                </SpaceBetween>
            }
        />
    );
};
